import { ExcelExport } from "@progress/kendo-react-excel-export"
import { compose, withHooks, withStores } from "enhancers"
import get from "lodash/get"
import { useEffect, useState } from "react"
import appStore from "stores/appStore"

const ExcelGeneratorComponent = ({ setExporter, ...rest }: any) => <ExcelExport {...rest} ref={setExporter} />

const enhancer = compose(
  withStores((stores: any, props: any) => (props.storeName ? get(stores, props.storeName) : {})),
  withHooks((props: any) => {
    const { fileName, columns, data, triggeredGenerator, onGenerated } = props
    const [exporter, setExporter] = useState<any>()

    useEffect(() => {
      if (triggeredGenerator) {
        exporter.save()
        if (onGenerated) {
          onGenerated()
        }
      }
    }, [exporter, triggeredGenerator, onGenerated])

    return {
      setExporter,
      fileName,
      columns,
      data,
    }
  }),
)

const ExcelGenerator = enhancer(ExcelGeneratorComponent)

ExcelGenerator.generate = appStore.generateExcel

export default ExcelGenerator
